<template>
  <div class="page flex-col">
    <div class="group_5 flex-col">
      <div class="group_6 flex-row justify-between">
        <img
          class="thumbnail_3"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng9712dacb757b7efbd27dd57c05fca1a03e41c0414af4c74e2f5b7b65c9fa9e37.png"
        />
        <span class="text_3">构建“3+2+1”产业结构</span>
      </div>
      <div class="text-wrapper_1 flex-row">
        <span class="text_4">
          昌平区产业基础扎实，着力构建现代化产业体系，做大做强医药健康、先进能源、先进制造3个优势主导产业，积极培育金融服务、科技服务。
        </span>
      </div>
    </div>
    <img
      class="image_4"
      referrerpolicy="no-referrer"
      src="./assets/img/SketchPng72cfdb3aaca62b99245ed001de330cac28cec70491300bdade82e2a5de83b753.png"
    />
    <div class="group_7 flex-col">
      <div class="block_1 flex-row">
        <div class="image-text_9 flex-row justify-between">
          <img
            class="thumbnail_4"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng9712dacb757b7efbd27dd57c05fca1a03e41c0414af4c74e2f5b7b65c9fa9e37.png"
          />
          <div class="text-group_9 flex-col">
            <span class="text_5">医药健康</span>
            <span class="text_6">
              形成了基础研究、中试研发、生产流通、终端医疗的完整产业链，百济神州、诺诚健华等800余家创新型企业繁荣发展。
            </span>
          </div>
        </div>
      </div>
    </div>
    <img
      class="image_5"
      referrerpolicy="no-referrer"
      src="./assets/img/SketchPng380cbab89569fcb3529aefe404c176d140e2a133ae07d2ffb78700f8807bf4c5.png"
    />
    <div class="group_8 flex-col">
      <div class="image-text_10 flex-row justify-between">
        <img
          class="thumbnail_5"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng9712dacb757b7efbd27dd57c05fca1a03e41c0414af4c74e2f5b7b65c9fa9e37.png"
        />
        <div class="text-group_10 flex-col">
          <span class="text_7">先进能源</span>
          <span class="text_8">3大赛道，7个先进能源细分领域，21项关键技术创新和产业培育。</span>
        </div>
      </div>
      <img
        class="image_6"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPng48d950e08e37b0a10131865fc7f6f15986e6048111dac34d684231ecca456a72.png"
      />
      <div class="image-text_11 flex-row justify-between">
        <img
          class="thumbnail_6"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng9712dacb757b7efbd27dd57c05fca1a03e41c0414af4c74e2f5b7b65c9fa9e37.png"
        />
        <div class="text-group_11 flex-col">
          <span class="text_9">先进制造</span>
          <span class="text_10">
            促进互联网、大数据、人工智能和制造业深度融合，推动产业数字化、高端化、智能化发展。
          </span>
        </div>
      </div>
    </div>
    <img
      class="image_7"
      referrerpolicy="no-referrer"
      src="./assets/img/SketchPng453fd2c0c642ac50a1143be78e7603c3620c65ab114515aff7f131a5eab9927b.png"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />